import React, { FC } from 'react';
import { IFormattedProviderProps } from '../../store/tables/admin/provider-data';
import { ErrorNotificationComponent } from '../application/ErrorNotificationComponent';
import { getFormattedDate } from '../../utils/utilities';
import { BUTTON_TYPE } from '../ButtonComponent';

interface Props {
  data: IFormattedProviderProps;
  openReleaseModal: () => void;
  isActive: boolean;
  onDeactivate: () => Promise<void>;
}
export const ProviderDetailsNotification: FC<Props> = (props) => {
  const { data, openReleaseModal, onDeactivate, isActive } = props;

  const quarantine = data?.cycleMetrics?.quarantine_AddedOn;

  const title = (
    <span className="fs-6">
      <span>This MID is quarantined since</span>
      <span className="ms-1">{getFormattedDate(quarantine, 'dd MMM, yyyy hh:mm a')}</span>
    </span>
  );

  return (
    <>
      {
        quarantine && (
          <ErrorNotificationComponent
            title={title}
            bodyAdditionalClass='p-5'
            primaryButtonName='Release MID'
            primaryButtonAdditionalClass='fs-8 py-2 no-letter-spacing'
            primaryButtonAction={openReleaseModal}

            secondaryButtonName={isActive ? 'Deactivate MID' : ''}
            secondaryButtonAdditionalClass='fs-8 py-2 no-letter-spacing'
            secondaryButtonType={BUTTON_TYPE.FAKE_LINK}
            secondaryButtonWithoutUnderline
            secondaryButtonAction={onDeactivate}
          />
        )
      }
    </>
  );
};